module.exports = __webpack_public_path__ + "static/media/YF02_4.4ac8b68b.jpg";